import React, { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useUserAuthStore } from "../context/useUserAuthStore";
import "../styles/AppHeader.css";

const AppHeader = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [profileOpen, setProfileOpen] = useState(false);
  const toggleMenu = () => setMenuOpen(!menuOpen);
  const closeMenu = () => setMenuOpen(false);
  const navigate = useNavigate();

  const { currentUser, logout } = useUserAuthStore();

  const handleLogout = () => {
    logout();
    setProfileOpen(false);
    navigate("/login");
  };

  const initials =
    currentUser?.firstname && currentUser?.lastname
      ? `${currentUser.firstname[0]}${currentUser.lastname[0]}`.toUpperCase()
      : "U";

  return (
    <header className="app-header">
      <div className="nav-container">
        {/* --- Logo + Title --- */}
        <div className="logo-group">
          <img src="/logo192.png" alt="App Logo" className="app-logo" />
        </div>

        {/* --- Navigation Links --- */}
        <nav className={`nav-links ${menuOpen ? "open" : ""}`}>
          <NavLink
            to="/dashboard"
            onClick={closeMenu}
            className={({ isActive }) =>
              isActive ? "nav-link active" : "nav-link"
            }
          >
            Dashboard
          </NavLink>

          <NavLink
            to="/alerts"
            onClick={closeMenu}
            className={({ isActive }) =>
              isActive ? "nav-link active" : "nav-link"
            }
          >
            Alerts
          </NavLink>

          <NavLink
            to="/trips"
            onClick={closeMenu}
            className={({ isActive }) =>
              isActive ? "nav-link active" : "nav-link"
            }
          >
            Trips
          </NavLink>

          <NavLink
            to="/reports"
            onClick={closeMenu}
            className={({ isActive }) =>
              isActive ? "nav-link active" : "nav-link"
            }
          >
            Reports
          </NavLink>

          <NavLink
            to="/geofences"
            onClick={closeMenu}
            className={({ isActive }) =>
              isActive ? "nav-link active" : "nav-link"
            }
          >
            Geofences
          </NavLink>

          <NavLink
            to="/settings"
            onClick={closeMenu}
            className={({ isActive }) =>
              isActive ? "nav-link active" : "nav-link"
            }
          >
            Settings
          </NavLink>

        </nav>

        {/* --- User Profile Dropdown --- */}
        <div className="profile-section">
          <div
            className="profile-avatar"
            onClick={() => setProfileOpen(!profileOpen)}
            title={currentUser?.email}
          >
            {currentUser?.profilePic ? (
              <img src={currentUser.profilePic} alt="User" />
            ) : (
              <span>{initials}</span>
            )}
          </div>

          {profileOpen && (
            <div className="profile-dropdown">
              <div className="profile-info">
                <strong>
                  {currentUser?.firstname} {currentUser?.lastname}
                </strong>
                <p>{currentUser?.email}</p>
              </div>
              <hr />
              <button onClick={handleLogout}>Logout</button>
            </div>
          )}
        </div>

        {/* --- Mobile Hamburger --- */}
        <button
          className={`hamburger ${menuOpen ? "open" : ""}`}
          onClick={toggleMenu}
          aria-label="Menu"
        >
          <span />
          <span />
          <span />
        </button>
      </div>
    </header>
  );
};

export default AppHeader;
